









import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { State } from 'vuex-class'

import CurrencyExchangeTradeHelperComponents2Header from './currency-exchange-trade-helper-components-2-header.vue'

// const namespace = 'digitalCurrency'

@Component({
  name: 'TransactionHelperComponents1MainPage',
  components: {
    CurrencyExchangeTradeHelperComponents2Header
  }
})
class TransactionHelperComponents1MainPage extends Vue {
  @State('isMobileDevice') isMobileDevice?: boolean

  @Prop({ default: '' }) transactionId?: string
  @Prop({ default: false }) showInNav?: boolean


  emitToggleShowContent ({ contentName, isVisible }: { contentName: string, isVisible?: boolean}) {
    this.$emit('toggleShowContent', { contentName, isVisible })
  }
}
export default TransactionHelperComponents1MainPage
